import { render, staticRenderFns } from "./voidlistesi.vue?vue&type=template&id=28926b85"
import script from "./voidlistesi.vue?vue&type=script&lang=js"
export * from "./voidlistesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports